import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { Checkbox } from "@/shared/components/check-box/check-box";
import { useReceiveMailsContext } from "@/features/user/contexts/receive-mails-context";
import { useUpdateUserInfo } from "@/features/user/hooks/use-update-user-info";


interface Props {
  onTapCloseModal: () => void;
}

// メール配信設定モーダル
export const MailSettingsModal = ({ onTapCloseModal }: Props) => {
  const {
    isReceiveNoticeMail,
    isReceiveErrorMail,
    setIsReceiveNoticeMail,
    setIsReceiveErrorMail
  } = useReceiveMailsContext();
  const {
    onClickUpdate,
  } = useUpdateUserInfo({ onTapCompleteModal: () => {} });

  const handleChangeNoticeMail = (checked: boolean) => {
    onClickUpdate(
      undefined, // ユーザ名
      checked, // お知らせメール配信
    );
    setIsReceiveNoticeMail(checked);
  };
  
  const handleChangeErrorMail = (checked: boolean) => {
    onClickUpdate(
      undefined, // ユーザ名
      undefined, // お知らせメール配信
      checked, // エラーメール配信
    );
    setIsReceiveErrorMail(checked);
  };

  return (
    <BasePageModal
      title="メールの配信設定"
      className="md-user-send"
      handleClose={() => {
        onTapCloseModal();
      }}
    >
      <h2>メールで通知したい項目をチェックしてください</h2>
      <ul>
        <li>
          <Checkbox
            label="新しいお知らせを通知"
            id="notice-mail-checkbox"
            labelClassName="btn-mail"
            checked={isReceiveNoticeMail}
            handleChange={(checked) => handleChangeNoticeMail(checked)}
          />
        </li>
        <li>
          <Checkbox
            label="明細取込エラーを通知"
            id="error-mail-checkbox"
            labelClassName="btn-bell"
            checked={isReceiveErrorMail}
            handleChange={(checked) => handleChangeErrorMail(checked)}
          />
        </li>
      </ul>
    </BasePageModal>
  );
};